export default "__VITE_ASSET__BOt5LJsY__"